import { IntlShape } from 'react-intl'
import { CrmIntakeView, CrmTrackView } from '../../../features/crm/crmApi'
import { daysTo, dictLabel } from './format'
import { Tone } from './crmUi'
import { tone } from '../../../utils/uiTokens'

type Fm = IntlShape['formatMessage']

// Что видит продажник: только свой этап
export const sellerStage = (fm: Fm, x: CrmIntakeView): { text: string; tone: Tone } => {
    if (x.status === 'RETURNED') return { text: `${fm({ id: 'crmReturn' })} · ${dictLabel(fm, 'Ret', x.returnReason)}`, tone: 'bad' }
    if (x.status === 'DELETED') return { text: fm({ id: 'crmDeleted' }), tone: 'bad' }
    if (x.stopped) return { text: fm({ id: 'crmStageStopped' }), tone: 'wait' }
    if (x.status === 'MODERATION') return { text: fm({ id: 'crmAtModerator' }), tone: 'wait' }
    return { text: fm({ id: 'crmModeratorApproved' }), tone: 'ok' }
}

// три блока списка учеников: учатся / приостановили / возврат
export type StuState = 'study' | 'stop' | 'ret'
export const stuState = (x: CrmIntakeView): StuState => (x.status === 'RETURNED' ? 'ret' : x.stopped ? 'stop' : 'study')

export const trackDone = (t: CrmTrackView) => t.stage === 'DONE' || t.verifiedCount >= 5

// Кезең у пән басшы
export const headStage = (fm: Fm, t: CrmTrackView): { text: string; tone: Tone } => {
    if (!t.mentorId) return { text: fm({ id: 'crmWaitGroupMentor' }), tone: 'wait' }
    if (trackDone(t)) return { text: fm({ id: 'crmFinishedCheck' }), tone: 'ok' }
    return { text: fm({ id: 'crmUploadedVerified' }, { done: t.doneCount, verified: t.verifiedCount }), tone: 'grey' }
}

// Колонка канбана ментора
export const mentorColumn = (t: CrmTrackView): 'todo' | 'doing' | 'done' => {
    if (trackDone(t)) return 'done'
    if (!t.doneCount && !(t.steps ?? []).some((s) => s.photos?.length)) return 'todo'
    return 'doing'
}

// Рассрочка: цвет и текст по payState. Доступ по сроку не закрывается - только предупреждение.
export const payStateView = (fm: Fm, x: CrmIntakeView): { text: string; tone: Tone; row: string } => {
    const d = daysTo(x.accessUntil)
    switch (x.payState) {
        case 'DONE':
            return { text: fm({ id: 'crmPayDone' }), tone: 'ok', row: '' }
        case 'PENDING':
            return { text: fm({ id: 'crmPayPending' }), tone: 'blue', row: tone.info.bg }
        case 'LATE':
            return { text: fm({ id: 'crmPayLate' }, { n: Math.max(1, -d) }), tone: 'bad', row: tone.bad.bg }
        case 'SOON':
            return { text: d <= 0 ? fm({ id: 'crmPayToday' }) : fm({ id: 'crmPayDaysLeft' }, { n: d }), tone: 'wait', row: tone.warn.bg }
        case 'OK':
            return { text: fm({ id: 'crmPayDaysLeft' }, { n: d }), tone: 'ok', row: '' }
        default:
            return { text: fm({ id: x.status === 'APPROVED' ? 'crmPayNoDate' : 'crmPayWaitModerator' }), tone: 'grey', row: '' }
    }
}
